import application_settings from '../applicationSettings';
import LocalStorage from '../local_data';
import Event from './Event';

class ValidateDiscountCode extends Event {
    eventName = 'oms_validateDiscountCode';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Validate Discount Code
     * 
     * @param {string} data.discount_code -  discount code
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';
        let discountCode = data.discount_code;
        let currentLocation = new LocalStorage.CurrentLocation(clientId).getData();

        if (discountCode) {

            // request data
            data.endPoint = application_settings.endPoints.validateDiscountCode;
            data.method = 'POST';
            data.multi_call_key = (data.multi_call_key) ? data.multi_call_key : 'validate_discount_code';
            data.data = {
                client_id: clientId,
                discount_code: discountCode
            };
        
            // send request
            this.sendRequest(data, function (response) {
              if (response) {

                //format response data
                let data = thisObj.formatResponseData(response);
                    
                let discountCodeData = new LocalStorage.DiscountCode(currentLocation);

                if (data.success) {
                    //add data to storage
                    discountCodeData.setData(discountCode);
                }
                else {
                    discountCodeData.setData(null);
                }

                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
              }
            });

        } else {
            //fire error event
            thisObj.onErrorEvent({ "message": "discount_code is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }
}

export default ValidateDiscountCode;